import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";

async function validateVatNumber(values) {
    try {
        const token = getToken();
        const response = await axiosInstance.get(`/api/taxes/validate-vat?countryCode=${values.countryCode}&vatNumber=${values.vatNumber}`, {
            headers: {
                'Authorization': token
            }
        });

        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export default validateVatNumber;
